var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M14.6168 7.34154C15.9791 7.34154 17.0835 6.23717 17.0835 4.87487C17.0835 3.51257 15.9791 2.4082 14.6168 2.4082C13.2545 2.4082 12.1501 3.51257 12.1501 4.87487C12.1501 6.23717 13.2545 7.34154 14.6168 7.34154Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.38341 7.34154C6.74572 7.34154 7.85008 6.23717 7.85008 4.87487C7.85008 3.51257 6.74572 2.4082 5.38341 2.4082C4.02111 2.4082 2.91675 3.51257 2.91675 4.87487C2.91675 6.23717 4.02111 7.34154 5.38341 7.34154Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6167 17.5916C15.979 17.5916 17.0834 16.4873 17.0834 15.125C17.0834 13.7626 15.979 12.6583 14.6167 12.6583C13.2544 12.6583 12.1501 13.7626 12.1501 15.125C12.1501 16.4873 13.2544 17.5916 14.6167 17.5916Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M5.38333 17.5916C6.74564 17.5916 7.85 16.4873 7.85 15.125C7.85 13.7626 6.74564 12.6583 5.38333 12.6583C4.02103 12.6583 2.91667 13.7626 2.91667 15.125C2.91667 16.4873 4.02103 17.5916 5.38333 17.5916Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1ac7626a79a1ae9a1592ef56f5cd5ff0.svg";
export { ForwardRef as ReactComponent };